/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/no-anonymous-default-export */
import React, { useEffect, useState } from 'react'
import styles from "./CategorySlider.module.css"
import Slider from "react-slick";
import axios from 'axios';
export default function () {
    const [categories,setCategories] = useState([]);
    async function getCategories() {
        let {data} = await axios.get(`https://ecommerce.routemisr.com/api/v1/categories`);
            setCategories(data.data);
        }
    useEffect(()=> {
        getCategories();
    }, [])
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 7,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1024,
            settings: {
            slidesToShow: 4,
            slidesToScroll: 2,
            infinite: true,
            dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1
            }
        }
    ]
        };
    return (
        <>
            <Slider {...settings} className='mt-5'>
                        {categories?.map((category) => <div key={category._id }>
                            <img height={200} className='w-100' src={category.image} />
                            <h2 className='h6 pt-2'>{category.name}</h2>
                        </div>)}
            </Slider>
        </>
    )
}
